import * as d3 from "d3";
import * as utils from "../utils/utils.js";

export function render(){
    let color = d3.scaleLinear()
        .domain([1, 500])
        .range(["rgba(0,0,0,.2)", "black"])

    d3.selectAll(".ljs--lattice-plot")
     .filter(d=> d.type == "scatterplot" && d.column == 0)
     .each(function(d){
        let plot = d3.select(`#${d.parentId}-scatterplot`);
        let rect = plot.selectAll("rect")
            .data(d._userInput._data)
            .enter();
        rect.exit().remove();
        rect
            .append("rect")
            .merge(rect)
            .attr("x", e=> d.scale.x(e.x))
            .attr("y", e=> d.scale.y(e.y))
            .attr("width", d.innerWidth/49)
            .attr("height", d.innerHeight/49)
            .attr("fill", e=>color(e.c))

        var xAxis = d3.axisBottom()
            .scale(d.scale.x)
            .tickValues([d.scale.x.domain()[0], 0, d.scale.x.domain()[1]])
            .tickSizeInner(d.innerHeight);

        let yAxis = d3.axisLeft()
            .scale(d.scale.y)
            .tickValues([d.scale.y.domain()[0], 0, d.scale.y.domain()[1]])
            .tickSizeInner(-d.innerWidth);

        plot.append("g").attr("class", "axis")
            .attr("transform", `translate(0,0)`)
            .call(xAxis)
            .selectAll("line").filter(d=>d==0).classed("dashed-line", true)


        plot.append("g").attr("class", "axis")
            .attr("transform", `translate(0,0)`)
            .call(yAxis)
            .selectAll("text")
            .attr("dy", (e)=>{
                if (e==0){ return 0 }
                else { return utils.dy.tick }
            })
            if (d.row==0){
                plot.append("text").html("-Log10 (p value)")
                    .attr("class", "sm-axis-title")
                    .attr("transform", `rotate(-90)`)
                    .attr("x", -d.innerHeight/2)
                    .attr("y", -d.padding.left*.8)
                    .attr("text-anchor", "middle")
    
                plot.append("text").html("Log2 (fold change)")
                    .attr("class", "sm-axis-title")
                    .attr("x", d.innerWidth/2)
                    .attr("y", d.innerHeight + (d.padding.bottom/1.5))
                    .attr("text-anchor", "middle")
            }
    })
}

